/**
 * RTL boot.
 *
 * `index.html` declares `<html lang="fa" dir="rtl">`; this re-applies it at
 * runtime so the console is still correct if the built bundle is served from a
 * template that dropped the attributes (nginx alias mount, iframe embed).
 */

export const UI_LANG = 'fa';
export const UI_DIR = 'rtl';

export function applyRtlDocument(doc: Document = document): void {
  const root = doc.documentElement;
  root.setAttribute('dir', UI_DIR);
  root.setAttribute('lang', UI_LANG);
}

/** True when the document is configured the way this console must run. */
export function isRtlDocument(doc: Document = document): boolean {
  return doc.documentElement.getAttribute('dir') === UI_DIR;
}

/**
 * Localised machine-readable ISO string for `time`/`title` attributes: the
 * visible text is Persian, but tooltips keep the exact wire value for
 * copy-paste into tickets.
 */
export function wireTitle(iso: string | null | undefined): string {
  return iso ? `ISO: ${iso}` : 'no timestamp';
}
